"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoteKintsugiAmount = exports.VoteKintsugi = void 0;
const _1 = require(".");
const monetary_1 = require("../monetary");
exports.VoteKintsugi = Object.assign(Object.assign({}, _1.Kintsugi), { ticker: "VKINT" });
class VoteKintsugiAmount extends monetary_1.MonetaryAmount {
}
exports.VoteKintsugiAmount = VoteKintsugiAmount;
VoteKintsugiAmount.from = monetary_1.generateFromConversions(exports.VoteKintsugi, _1.Kintsugi.units);
VoteKintsugiAmount.zero = VoteKintsugiAmount.from.KINT(0);
